import { Component, OnInit } from '@angular/core';
import { StudentClassroomNavbarComponent } from '../student-classroom-navbar/student-classroom-navbar.component';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ClassroomDetailPage, ClassroomDetailPageResponse } from '@edtech-ui/core/models/Classroom/classrom-detail-page';
import { ClassroomManagementService } from '@edtech-ui/core/services/classroom-management-service/classroom-management.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-students-classroom-detail-page',
	standalone: true,
	imports: [StudentClassroomNavbarComponent, MatIcon, RouterModule, MatTooltipModule],
	templateUrl: './students-classroom-detail-page.component.html',
	styleUrl: './students-classroom-detail-page.component.scss'
})
export class StudentsClassroomDetailPageComponent implements OnInit {

	_classroom: ClassroomDetailPage = {
		id: 0,
		name: 'N/A',
		subject: 'N/A',
		grade_level: 'N/A',
		cover_image_url: '',
		class_code: '',
		created_by: '',
		is_active: true,
		student_count: 0,
		teacher_name: 'N/A'
	};
	classroomId: string | null = null;
	private subscription = new Subscription();

	constructor(
		private route: ActivatedRoute,
		private _classroomService: ClassroomManagementService,
		private _toastr: ToastrService
	) { }

	ngOnInit(): void {
		this.classroomId = this.route.snapshot.paramMap.get('id');
		if (this.classroomId) {
			this.getClassById(this.classroomId);
		} else {
			this._toastr.error('Classroom ID not found.');
			this._classroom = {
				id: 0,
				name: 'N/A',
				subject: 'N/A',
				grade_level: 'N/A',
				cover_image_url: '',
				class_code: '',
				created_by: '',
				is_active: true,
				student_count: 0,
				teacher_name: 'N/A'
			};
		}
	}

	getClassById(classroomId: string): void {
		this.subscription.add(
			this._classroomService.getClassroomById(classroomId).subscribe({
				next: (response: ClassroomDetailPageResponse) => {
					if (response.Success) {
						this._classroom = response.Data;
					} else {
						this._toastr.error(response.Message || 'Failed to fetch classroom details.');
						this._classroom = {
							id: +classroomId,
							name: 'N/A',
							subject: 'N/A',
							grade_level: 'N/A',
							cover_image_url: '',
							class_code: '',
							created_by: '',
							is_active: true,
							student_count: 0,
							teacher_name: 'N/A'
						};
					}
				},
				error: (err) => {
					this._toastr.error('An error occurred while fetching classroom details. Please try again.');
					this._classroom = {
						id: +classroomId,
						name: 'N/A',
						subject: 'N/A',
						grade_level: 'N/A',
						cover_image_url: '',
						class_code: '',
						created_by: '',
						is_active: true,
						student_count: 0,
						teacher_name: 'N/A'
					};
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}